
import { useState } from "react";
import ModalVideo from "react-modal-video";
import videoThumb from "../../../assets/images/all-img/about/video-thumb2.png";
import videoBtn from "../../../assets/images/all-img/video-btn.png";
import playBtn from "../../../assets/images/all-img/play-btn.png";

export default function VideoSectionOne({ marginBottom }) {
	const [isOpen, setOpen] = useState(false);
	return (
		<div className="section fugu-team-page" style={{ marginBottom: marginBottom ? "100px" : null }}>
			<div className="container">
				<div className="fugu-section-title max-w-full">
					<h2>We are a team of talented people</h2>
				</div>
				<div className="fugu-video-thumb fugu-video-thumb3 wow fadeInUpX" data-wow-delay=".10s">
					<img src={videoThumb} alt="" />
					<div className="fugu-popup">
						<img src={videoBtn} alt="" />
						<div className="fugu-play-btn" onClick={() => setOpen(true)}>
							<img src={playBtn} alt="" />
						</div>
					</div>
				</div>
			</div>
			<ModalVideo
				channel="youtube"
				autoplay
				isOpen={isOpen}
				videoId="E1xkXZs0cAQ"
				onClose={() => setOpen(false)}
			/>
		</div>
	);
}
